<template>
	<div class="page-about">
		<section class="container">
			<div class="row justify-content-md-between align-items-center justify-content-center text-center text-md-left">
				<div class="col-md-6">
					<h2>Munus</h2>
					<p class="lead pr-md-35">2D and 3D Acoustical Visualization and Analysis Software</p>
					<router-link to="/contact">Get in Touch »</router-link> 
				</div>
				<div class="col-md-5 col-4 order-first order-md-last spaced-sm">
					<img src="@/assets/munus-logo_v2.png" alt="Munus">
				</div>
			</div>
		</section>		
		<section class="gray-section">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-8 text-center">
						<h2>Powerful and easy to use</h2>
						<img src="@/assets/Munus_screen.jpg" alt="Munus">
						<p class="lead">With a clean yet powerful interface, the user will quickly master the system</p>
					</div>
				</div>
			</div>
		</section>
		<section class="features">
			<div class="container">
				<div class="row text-center text-md-left mb-5">
					<div class="col-md-4">
						<div class="box">
							<h4>Recording</h4>
							<p>Munus is able to stream and process data in real time, as well as storing it for later analysis. Integration with parameter database is possible</p>
						</div>
					</div>
					<div class="col-md-4">
						<div class="box">
							<h4>Modern Processing</h4>
							<p>By utilizing powerful modern GPUs for processing, Munus is able to speed up processing of large files, eliminating the need for specialized hardware</p>						
						</div>
					</div>
					<div class="col-md-4">
						<div class="box">
							<h4>Operator assistance</h4>
							<p>Algorithms to assist the analysis runs in the background and integrates to the users workflow</p>						
						</div>
					</div>
				</div>
<!-- 				<div class="row text-center text-md-left">
					<div class="col-md-4">
						<div class="box">
							<h4>Experience Quality</h4>
							<p>Lorem ipsum dolor sit amet, consect beatae adipisicing elit.</p>
						</div>
					</div>
					<div class="col-md-4">
						<div class="box">
							<h4>Robust Design</h4>
							<p>Lorem ipsum dolor sit amet, consect beatae adipisicing elit.</p>						
						</div>
					</div>
					<div class="col-md-4">
						<div class="box">
							<h4>Downloadable Data</h4>
							<p>Lorem ipsum dolor sit amet, consect beatae adipisicing elit.</p>						
						</div>
					</div>
				</div> -->
			</div>
		</section>
		<section class="gray-section">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-8 text-center">
						<h2>Key features</h2>
						<!-- img src="@/assets/BW_workflow_diagram.png" alt="BattleWikiX" -->
						<p class="lead">Key features:
							<ul>
								<li>All the heavy lifting is done on the GPU, enabling powerful analysis to be done on a normal workstation</li>
								<li>The SAFE (Super Accurate Frequency Estimation) and other novel techniques available</li>
								<li>Provides the ability to process and analyze multiple hours of data with a customizable buffer</li>
							</ul>
						</p>
					</div>
				</div>
			</div>
		</section>
		<section class="cta product-cta">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-8 text-center">
						<!-- <h2>Let's discuss</h2>
						<p class="lead">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam, consequuntur eligendi a architecto est ab explicabo sequi.</p> -->
						<router-link to="/contact" class="btn btn-primary btn-main">Get in touch</router-link>
					</div>
				</div>
			</div>
		</section>
	</div>	
</template>

<script>
export default {
	name: 'Munus',
	components: {

	}
}
</script>

<style>
	.product-cta {
		background-image: url(~@/assets/slide-4.jpg);
		background-position: center;
	}
</style>
